import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgEmptyState = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: "1em",
	height: "1em",
	viewBox: "0 0 128 128",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M26.4003 75.5555C32.8003 66.7555 51.2002 64.3555 51.2002 64.3555C64.6402 70.7555 73.5 67.5 75.5 64C75.5 64 88.0003 65.1555 96.0002 70.7555C104 76.3555 109.6 113.155 109.6 113.155H84.0003C90.8055 112.101 93.4507 110.761 94.4003 105.955C93.8184 101.806 93.5202 100.729 91 98L85.6003 98.7555L84.0003 83.5555C83.9592 82.4378 83.8813 81.8463 82.5 81.5L56.8003 83.5555C54.7264 83.4485 53.9753 83.9106 53.6003 85.9555L55.2003 99.5555H62.4003C60.7797 105.111 60.109 108.237 61.6003 113.955L24.8003 114.755C24.8003 114.755 20.0003 84.3555 26.4003 75.5555Z",
			stroke: "black"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M80.8 37.9556C80.8 45.1556 83.2 64.3556 64 57.1556",
			stroke: "black"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M75.2002 57.9556V63.5556",
			stroke: "black"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M51.2002 63.5552C51.2002 67.5552 75.2002 70.7552 75.2002 63.5552",
			stroke: "black"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M72.8 36.3555L74.4 41.1555L72 42.7555",
			stroke: "black"
		}),
		/* @__PURE__ */ _jsx("circle", {
			cx: 66.4001,
			cy: 35.5554,
			r: .8,
			fill: "black"
		}),
		/* @__PURE__ */ _jsx("circle", {
			cx: 77.6003,
			cy: 35.5554,
			r: .8,
			fill: "black"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M54.3999 113.955C55.8432 113.595 84.7999 113.955 90.3999 111.555C96.7999 109.955 94.0171 101.155 91.9999 98.7554C89.9827 96.3554 85.5999 99.5554 85.5999 99.5554C85.5999 99.5554 85.4 95 83 95C80.6 95 77.5999 99.5554 76.7999 99.5554C75.9999 99.5554 43 100 43 100",
			stroke: "black"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M42.5 96L41.6001 85.1553",
			stroke: "black"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M57.5 100C56.4333 101.333 53.9202 106.915 55.2002 113.955",
			stroke: "black"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M63.2003 99.5552C62.1336 100.889 59.8656 106.115 61.1456 113.155",
			stroke: "black"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M73.6003 46.7553C72.0003 47.5553 70.4003 47.5553 68.8003 45.1553",
			stroke: "black",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("ellipse", {
			cx: 66.3999,
			cy: 35.5556,
			rx: 4,
			ry: 5.6,
			stroke: "black"
		}),
		/* @__PURE__ */ _jsx("ellipse", {
			cx: 78.4002,
			cy: 34.7556,
			rx: 3.2,
			ry: 4.8,
			stroke: "black"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M52.0001 40.3554C52.0001 40.3554 67.2001 32.3554 65.6001 22.7554C68.8001 26.7554 79.2001 22.7554 81.6001 31.5554C83.2001 27.5554 83.6698 25.4967 82.4001 21.9553C79.9659 15.1658 69.6001 9.95534 64.8001 16.3554C57.6001 9.15534 43.2 13.1554 41.6001 25.9554C40.0002 38.7554 27.8002 40.3554 30.4002 50.7554C33.0002 61.1554 44.0001 65.9554 44.0001 65.9554L52.0001 64.3554L51.2001 45.9554C48.5335 44.3554 45.5619 40.3745 48.8001 38.7554C50.4001 37.9554 51.2001 39.5554 52.0001 40.3554Z",
			fill: "black"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M84.8002 65.9554C90.4002 57.9554 84.2 50.1 81 40.5C81 55.5 79 55.5 75.2002 57.9554V64.3554L84.8002 65.9554Z",
			fill: "black"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M55.2001 100.355L53.7928 85.5787C53.6869 84.4665 54.5126 83.4832 55.6264 83.3953L82.0298 81.3108C83.1217 81.2246 84.0799 82.0327 84.179 83.1235L85.6001 98.7553",
			stroke: "black"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M9.6001 114.755L120 113.155",
			stroke: "black"
		})
	]
});
export default SvgEmptyState;
